import { TYPES } from '@/engine/ioc';
import type { IToastOptions, ToastNotificationsController } from './ToastNotifications.controller';
import { EToastKind } from './ToastNotifications.controller';
import type { BaseVariant} from 'notistack';
import { enqueueSnackbar, SnackbarProvider } from 'notistack';
import { useInjection } from 'inversify-react';
import { useEffect } from 'react';
import type { AppController } from '@/engine/app/App.controller';

function _ToastKindToSnackbarVariant(kind: EToastKind): BaseVariant {
  switch (kind) {
    case EToastKind.Error:
      return 'error';
    case EToastKind.Success:
      return 'success';
    case EToastKind.Warning:
      return 'warning';
    case EToastKind.Info:
      return 'info';
  }
  return 'default';
}

export const ToastNotifications: React.FC = () => {
  const toastNotificationsCenter = useInjection<ToastNotificationsController>(TYPES.ToastNotificationsController);
  const appController = useInjection<AppController>(TYPES.AppController);

  useEffect(() => {
    if (appController.surgeryType !== 'LUNG') {
      const subscription = toastNotificationsCenter.subscribe((message: string, options: IToastOptions): void => {
        enqueueSnackbar(message, {
          variant: _ToastKindToSnackbarVariant(options.kind),
          autoHideDuration: options.timeoutMs
        });
      });
      return (): void => subscription.unsubscribe();
    }
  }, [toastNotificationsCenter, appController.surgeryType]);

  return <SnackbarProvider />;
};
